import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building, AlertCircle } from 'lucide-react';
import { useOrg } from '../contexts/OrgContext';
import { Alert, AlertDescription } from './ui/alert';

/**
 * Écran « organisation » ouvert par un admin qui n'a pas choisi sur laquelle il
 * travaille.
 *
 * Sans ce garde-fou, la page agirait sur l'organisation du COMPTE admin —
 * exactement le défaut qu'on corrige : déclarer un régime TVA ou connecter un
 * compte Stripe pour « Pax Technologies » en croyant le faire pour le client
 * dont on regarde l'événement. On demande donc, au lieu de deviner.
 *
 * Invisible pour un organisateur : il n'a qu'une organisation, la sienne.
 */
export const OrganizationRequired: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="flex items-center gap-2">
        <Building size={14} className="shrink-0 opacity-70" />
        {t('nav.organizationRequired')}
      </AlertDescription>
    </Alert>
  );
};

/** `true` quand la page doit afficher l'avertissement au lieu de son contenu. */
export const useOrganizationRequired = (): boolean => useOrg().needsOrganization;

export default OrganizationRequired;
